import { NavLink } from 'react-router-dom'
import { RxHamburgerMenu as MenuIcon } from 'react-icons/rx'
import { IoMdClose as CloseIcon } from 'react-icons/io'
import { NavCta, NavLinkItem } from '../../../types/navigation'

interface PhoneNavProps {
	navLinks: NavLinkItem[]
	currentPageCTA?: NavCta
	showNav: boolean
	setShowNav: (showNav: boolean) => void
	className: string
}

const PhoneNav = ({ navLinks, currentPageCTA, showNav, setShowNav, className }: PhoneNavProps) => {
	return (
		<div className={className}>
			<button
				type="button"
				onClick={() => setShowNav(!showNav)}
				className="flex h-10 w-10 items-center justify-center rounded-lg border
					border-slate-200 text-slate-900"
				aria-expanded={showNav}
				aria-controls="phone-nav"
				aria-label={showNav ? 'Close menu' : 'Open menu'}
			>
				{showNav ? <CloseIcon size={20} /> : <MenuIcon size={18} />}
			</button>

			{showNav && (
				<nav
					id="phone-nav"
					className="absolute left-0 right-0 top-full border-t border-slate-200 bg-white"
					aria-label="Main"
				>
					<div className="mx-auto flex w-full max-w-7xl flex-col gap-1 px-5 py-4 sm:px-8">
						{navLinks.map((navLink) => (
							<NavLink
								key={navLink.to}
								to={navLink.to}
								className={({ isActive }) =>
									`rounded-lg px-3 py-3 text-[15px] ${
										isActive ? 'bg-slate-50 font-semibold text-slate-900' : 'text-slate-600'
									}`
								}
							>
								{navLink.name}
							</NavLink>
						))}

						{currentPageCTA && (
							<a
								href={currentPageCTA.href}
								className="btn-accent mt-2 px-5 py-3.5"
								onClick={() => setShowNav(false)}
							>
								{currentPageCTA.text}
							</a>
						)}
					</div>
				</nav>
			)}
		</div>
	)
}

export default PhoneNav
